import type { RouteItem } from "@/types/routes";
import type { ObjectCode } from "@/api/crm/schema/types";

export const ROLE_PERMISSIONS = {
  ACCOUNT_CURRENCY_VIEW: "account.currency.view",
  ACCOUNT_CURRENCY_MANAGE: "account.currency.manage",
  ACCOUNT_BILLING_MANAGE: "account.billing.manage",
  ACCOUNT_DEVELOPER_MANAGE: "account.developer.manage",
  ACCOUNT_EXPORT_CREATE: "account.export.create",
  ACCOUNT_EXPORT_VIEW: "account.export.view",
  ACCOUNT_FILES_GOVERN: "account.files.govern",
  ACCOUNT_FILES_METRICS: "account.files.metrics",
  ACCOUNT_FILES_READ: "account.files.read",
  ACCOUNT_FILES_SHARE: "account.files.share",
  ACCOUNT_FILES_WRITE: "account.files.write",
  ACCOUNT_FORMS_MANAGE: "account.forms.manage",
  ACCOUNT_IMPORT_MANAGE: "account.import.manage",
  ACCOUNT_PROJECTS_MANAGE: "account.projects.manage",
  ACCOUNT_PROPERTY_CREATE: "account.property.create",
  ACCOUNT_PROPERTY_DELETE: "account.property.delete",
  ACCOUNT_PROPERTY_UPDATE: "account.property.update",
  ACCOUNT_PROPERTY_VIEW: "account.property.view",
  ACCOUNT_ROLES_MANAGE: "account.roles.manage",
  ACCOUNT_TEAMS_MANAGE: "account.teams.manage",
  ACCOUNT_USERS_MANAGE: "account.users.manage",
  CRM_ACTIVITIES_CREATE: "crm.activities.create",
  CRM_ACTIVITIES_DELETE: "crm.activities.delete",
  CRM_ACTIVITIES_UPDATE: "crm.activities.update",
  CRM_ACTIVITIES_VIEW: "crm.activities.view",
  CRM_APPOINTMENT_BULKDELETE: "crm.appointment.bulkdelete",
  CRM_APPOINTMENT_BULKUPDATE: "crm.appointment.bulkupdate",
  CRM_APPOINTMENT_CREATE: "crm.appointment.create",
  CRM_APPOINTMENT_DELETE: "crm.appointment.delete",
  CRM_APPOINTMENT_UPDATE: "crm.appointment.update",
  CRM_APPOINTMENT_VIEW: "crm.appointment.view",
  CRM_CALL_BULKDELETE: "crm.call.bulkdelete",
  CRM_CALL_BULKUPDATE: "crm.call.bulkupdate",
  CRM_CALL_UPDATE: "crm.call.update",
  CRM_COMPANY_BULKDELETE: "crm.company.bulkdelete",
  CRM_COMPANY_BULKUPDATE: "crm.company.bulkupdate",
  CRM_COMPANY_CREATE: "crm.company.create",
  CRM_COMPANY_DELETE: "crm.company.delete",
  CRM_COMPANY_UPDATE: "crm.company.update",
  CRM_COMPANY_VIEW: "crm.company.view",
  CRM_CONTACT_BULKDELETE: "crm.contact.bulkdelete",
  CRM_CONTACT_BULKUPDATE: "crm.contact.bulkupdate",
  CRM_CONTACT_CREATE: "crm.contact.create",
  CRM_CONTACT_DELETE: "crm.contact.delete",
  CRM_CONTACT_UPDATE: "crm.contact.update",
  CRM_CONTACT_VIEW: "crm.contact.view",
  CRM_CONVERSATIONS_BULKUPDATE: "crm.conversations.bulkupdate",
  CRM_CONVERSATIONS_UPDATE: "crm.conversations.update",
  CRM_CONVERSATIONS_VIEW: "crm.conversations.view",
  CRM_DEAL_BULKDELETE: "crm.deal.bulkdelete",
  CRM_DEAL_BULKUPDATE: "crm.deal.bulkupdate",
  CRM_DEAL_CREATE: "crm.deal.create",
  CRM_DEAL_DELETE: "crm.deal.delete",
  CRM_DEAL_UPDATE: "crm.deal.update",
  CRM_DEAL_VIEW: "crm.deal.view",
  CRM_LEAD_BULKDELETE: "crm.lead.bulkdelete",
  CRM_LEAD_BULKUPDATE: "crm.lead.bulkupdate",
  CRM_LEAD_CREATE: "crm.lead.create",
  CRM_LEAD_DELETE: "crm.lead.delete",
  CRM_LEAD_UPDATE: "crm.lead.update",
  CRM_LEAD_VIEW: "crm.lead.view",
  CRM_MEETING_DELETE: "crm.meeting.delete",
  CRM_MEETING_BULKDELETE: "crm.meeting.bulkdelete",
  CRM_MEETING_BULKUPDATE: "crm.meeting.bulkupdate",
  CRM_MEETING_CREATE: "crm.meeting.create",
  CRM_MEETING_UPDATE: "crm.meeting.update",
  CRM_NOTES_VIEW: "crm.notes.view",
  CRM_NOTES_UPDATE: "crm.notes.update",
  CRM_NOTES_DELETE: "crm.notes.delete",
  CRM_NOTES_CREATE: "crm.notes.create",
  CRM_ORDER_DELETE: "crm.order.delete",
  CRM_ORDER_BULKDELETE: "crm.order.bulkdelete",
  CRM_ORDER_BULKUPDATE: "crm.order.bulkupdate",
  CRM_ORDER_UPDATE: "crm.order.update",
  CRM_PAYMENT_DELETE: "crm.payment.delete",
  CRM_PAYMENT_BULKDELETE: "crm.payment.bulkdelete",
  CRM_PAYMENT_BULKUPDATE: "crm.payment.bulkupdate",
  CRM_PAYMENT_UPDATE: "crm.payment.update",
  CRM_PRODUCT_BULKDELETE: "crm.product.bulkdelete",
  CRM_PRODUCT_BULKUPDATE: "crm.product.bulkupdate",
  CRM_PRICEBOOK_VIEW: "crm.pricebook.view",
  CRM_PRICEBOOK_MANAGE: "crm.pricebook.manage",
  CRM_PRODUCT_VIEW: "crm.product.view",
  CRM_PRODUCT_MANAGE: "crm.product.manage",
  CRM_PRODUCT_UPDATE: "crm.product.update",
  CRM_SEGMENTS_CREATE: "crm.segments.create",
  CRM_SEGMENTS_DELETE: "crm.segments.delete",
  CRM_SEGMENTS_UPDATE: "crm.segments.update",
  CRM_SEGMENTS_VIEW: "crm.segments.view",
  CRM_TASKS_DELETE: "crm.tasks.delete",
  CRM_TASKS_CREATE: "crm.tasks.create",
  CRM_TASKS_UPDATE: "crm.tasks.update",
  CRM_TASKS_VIEW: "crm.tasks.view",
  CRM_TICKET_BULKDELETE: "crm.ticket.bulkdelete",
  CRM_TICKET_BULKUPDATE: "crm.ticket.bulkupdate",
  CRM_TICKET_CREATE: "crm.ticket.create",
  CRM_TICKET_DELETE: "crm.ticket.delete",
  CRM_TICKET_UPDATE: "crm.ticket.update",
  CRM_TICKET_VIEW: "crm.ticket.view",
  CRM_WORKFLOWS_CREATE: "crm.workflows.create",
  CRM_WORKFLOWS_DELETE: "crm.workflows.delete",
  CRM_WORKFLOWS_UPDATE: "crm.workflows.update",
  CRM_WORKFLOWS_VIEW: "crm.workflows.view",
  MARKETING_LEADFORMS_CREATE: "marketing.leadforms.create",
  MARKETING_LEADFORMS_VIEW: "marketing.leadforms.view",
  MARKETING_LEADFORMS_EDIT: "marketing.leadforms.edit",
  MARKETING_CAMPAIGNS_CREATE: "marketing.campaigns.create",
  MARKETING_CAMPAIGNS_DELETE: "marketing.campaigns.delete",
  MARKETING_CAMPAIGNS_MANAGE: "marketing.campaigns.manage",
  MARKETING_CAMPAIGNS_UPDATE: "marketing.campaigns.update",
  MARKETING_CAMPAIGNS_VIEW: "marketing.campaigns.view",
  MARKETING_MESSAGES_SEND: "marketing.messages.send",
  MARKETING_MESSAGES_VIEW: "marketing.messages.view",
  MARKETING_TEMPLATES_DELETE: "marketing.templates.delete",
  MARKETING_TEMPLATES_MANAGE: "marketing.templates.manage",
  MARKETING_TEMPLATES_PUBLISH: "marketing.templates.publish",
  MARKETING_TEMPLATES_VIEW: "marketing.templates.view",
  SCHEDULING_BOOKINGS_UPDATE: "scheduling.bookings.update",
  SCHEDULING_BOOKINGS_VIEW: "scheduling.bookings.view",
  SCHEDULING_EVENT_TYPES_CREATE: "scheduling.event-types.create",
  SCHEDULING_EVENT_TYPES_DELETE: "scheduling.event-types.delete",
  SCHEDULING_EVENT_TYPES_UPDATE: "scheduling.event-types.update",
  SCHEDULING_EVENT_TYPES_VIEW: "scheduling.event-types.view",
  SCHEDULING_ROUTING_FORMS_CREATE: "scheduling.routing-forms.create",
  SCHEDULING_ROUTING_FORMS_DELETE: "scheduling.routing-forms.delete",
  SCHEDULING_ROUTING_FORMS_UPDATE: "scheduling.routing-forms.update",
  SCHEDULING_ROUTING_FORMS_VIEW: "scheduling.routing-forms.view",
  SCHEDULING_WORKSPACE_MANAGE: "scheduling.workspace.manage",
  SCHEDULING_WORKSPACE_VIEW: "scheduling.workspace.view",
  AUTOMATION_CHATBOT_CREATE: "automation.chatbot.create",
  AUTOMATION_CHATBOT_DELETE: "automation.chatbot.delete",
  AUTOMATION_CHATBOT_UPDATE: "automation.chatbot.update",
  AUTOMATION_CHATBOT_VIEW: "automation.chatbot.view",
  SECURITY_AUDIT_EXPORT: "security.audit.export",
  SECURITY_AUDIT_VIEW: "security.audit.view",
  SETTINGS_EMAIL_DOMAINS_CREATE: "settings.email_domains.create",
  SETTINGS_EMAIL_DOMAINS_DELETE: "settings.email_domains.delete",
  SETTINGS_EMAIL_DOMAINS_UPDATE: "settings.email_domains.update",
  SETTINGS_EMAIL_DOMAINS_VIEW: "settings.email_domains.view",

  MARKETING_CAMPAIGNS_EXECUTE: "marketing.campaigns.manage",
} as const;

export type RolePermissionKey =
  (typeof ROLE_PERMISSIONS)[keyof typeof ROLE_PERMISSIONS];

export type RuntimePermissionMap = Record<string, boolean>;

export type CrmObjectPermissionAction =
  | "view"
  | "create"
  | "edit"
  | "update"
  | "delete"
  | "bulkUpdate"
  | "bulkDelete";

export type CrmObjectPermissionKeys = Partial<
  Record<CrmObjectPermissionAction, RolePermissionKey>
>;

export const hasRuntimePermission = (
  permissionMap: RuntimePermissionMap,
  permissionKey?: string,
  isSuperAdmin = false,
): boolean => {
  if (!permissionKey || isSuperAdmin) return true;
  if (permissionMap["*"] === true) return true;
  if (Object.keys(permissionMap).length === 0) return true;
  return permissionMap[permissionKey] === true;
};

export const hasExplicitRuntimePermission = (
  permissionMap: RuntimePermissionMap,
  permissionKey?: string,
  isSuperAdmin = false,
): boolean => {
  if (!permissionKey || isSuperAdmin) return true;
  if (permissionMap["*"] === true) return true;
  return permissionMap[permissionKey] === true;
};

export const ROUTE_PERMISSION_MAP: Record<string, RolePermissionKey> = {
  tasks: ROLE_PERMISSIONS.CRM_TASKS_VIEW,
  contacts: ROLE_PERMISSIONS.CRM_CONTACT_VIEW,
  "contact-detail": ROLE_PERMISSIONS.CRM_CONTACT_VIEW,
  companies: ROLE_PERMISSIONS.CRM_COMPANY_VIEW,
  "company-detail": ROLE_PERMISSIONS.CRM_COMPANY_VIEW,
  deals: ROLE_PERMISSIONS.CRM_DEAL_VIEW,
  "deal-detail": ROLE_PERMISSIONS.CRM_DEAL_VIEW,
  leads: ROLE_PERMISSIONS.CRM_LEAD_VIEW,
  "lead-detail": ROLE_PERMISSIONS.CRM_LEAD_VIEW,
  tickets: ROLE_PERMISSIONS.CRM_TICKET_VIEW,
  "ticket-detail": ROLE_PERMISSIONS.CRM_TICKET_VIEW,
  appointments: ROLE_PERMISSIONS.CRM_APPOINTMENT_VIEW,
  "appointment-detail": ROLE_PERMISSIONS.CRM_APPOINTMENT_VIEW,
  segments: ROLE_PERMISSIONS.CRM_SEGMENTS_VIEW,
  "segment-active-members": ROLE_PERMISSIONS.CRM_SEGMENTS_VIEW,
  "segment-create": ROLE_PERMISSIONS.CRM_SEGMENTS_CREATE,
  "segment-edit": ROLE_PERMISSIONS.CRM_SEGMENTS_UPDATE,
  "segment-clone": ROLE_PERMISSIONS.CRM_SEGMENTS_CREATE,
  "workflow-automation": ROLE_PERMISSIONS.CRM_WORKFLOWS_VIEW,
  "workflows-list": ROLE_PERMISSIONS.CRM_WORKFLOWS_VIEW,
  "workflows-insights": ROLE_PERMISSIONS.CRM_WORKFLOWS_VIEW,
  "workflows-health": ROLE_PERMISSIONS.CRM_WORKFLOWS_VIEW,
  "workflow-event-management": ROLE_PERMISSIONS.CRM_WORKFLOWS_VIEW,
  "workflow-logs": ROLE_PERMISSIONS.CRM_WORKFLOWS_VIEW,
  "workflow-graph": ROLE_PERMISSIONS.CRM_WORKFLOWS_VIEW,
  "restore-activities": ROLE_PERMISSIONS.CRM_ACTIVITIES_VIEW,
  inbox: ROLE_PERMISSIONS.CRM_CONVERSATIONS_VIEW,
  "inbox-conversation": ROLE_PERMISSIONS.CRM_CONVERSATIONS_VIEW,
  "inbox-channel": ROLE_PERMISSIONS.CRM_CONVERSATIONS_VIEW,
  "inbox-quick-replies": ROLE_PERMISSIONS.CRM_CONVERSATIONS_VIEW,
  "lead-forms": ROLE_PERMISSIONS.MARKETING_LEADFORMS_VIEW,
  "whatsapp-templates": ROLE_PERMISSIONS.MARKETING_TEMPLATES_VIEW,
  "create-whatsapp-template": ROLE_PERMISSIONS.MARKETING_TEMPLATES_MANAGE,
  "edit-whatsapp-template": ROLE_PERMISSIONS.MARKETING_TEMPLATES_MANAGE,
  "view-whatsapp-template": ROLE_PERMISSIONS.MARKETING_TEMPLATES_VIEW,
  "email-templates": ROLE_PERMISSIONS.MARKETING_TEMPLATES_VIEW,
  "create-email": ROLE_PERMISSIONS.MARKETING_TEMPLATES_MANAGE,
  "edit-email": ROLE_PERMISSIONS.MARKETING_TEMPLATES_MANAGE,
  "campaign-management": ROLE_PERMISSIONS.MARKETING_CAMPAIGNS_VIEW,
  "campaign-create": ROLE_PERMISSIONS.MARKETING_CAMPAIGNS_MANAGE,
  "campaign-edit": ROLE_PERMISSIONS.MARKETING_CAMPAIGNS_MANAGE,
  "campaign-insights": ROLE_PERMISSIONS.MARKETING_CAMPAIGNS_VIEW,
  "schedule-workspace": ROLE_PERMISSIONS.SCHEDULING_WORKSPACE_VIEW,
  "schedule-workspace-members": ROLE_PERMISSIONS.SCHEDULING_WORKSPACE_VIEW,
  "schedule-workspace-availability": ROLE_PERMISSIONS.SCHEDULING_WORKSPACE_VIEW,
  "schedule-workspace-availability-schedule": ROLE_PERMISSIONS.SCHEDULING_WORKSPACE_VIEW,
  "meeting-scheduler": ROLE_PERMISSIONS.SCHEDULING_EVENT_TYPES_VIEW,
  "meeting-scheduler-event-type": ROLE_PERMISSIONS.SCHEDULING_EVENT_TYPES_UPDATE,
  "schedule-routing": ROLE_PERMISSIONS.SCHEDULING_ROUTING_FORMS_VIEW,
  "schedule-routing-create-form": ROLE_PERMISSIONS.SCHEDULING_ROUTING_FORMS_CREATE,
  "schedule-routing-edit-form": ROLE_PERMISSIONS.SCHEDULING_ROUTING_FORMS_UPDATE,
  "schedule-bookings": ROLE_PERMISSIONS.SCHEDULING_BOOKINGS_VIEW,
  "schedule-booking-details": ROLE_PERMISSIONS.SCHEDULING_BOOKINGS_VIEW,
  "schedule-booking-post-meeting": ROLE_PERMISSIONS.SCHEDULING_BOOKINGS_VIEW,
  "schedule-workspace-event-type-insights": ROLE_PERMISSIONS.SCHEDULING_BOOKINGS_VIEW,
  developer: ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-overview": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-apps": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-webhooks": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-webhooks-create": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-webhooks-details": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-apps-create": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-apps-edit": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-apps-details": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-api-keys": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-api-usages": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-api-keys-create": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-api-keys-edit": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "developer-api-keys-details": ROLE_PERMISSIONS.ACCOUNT_DEVELOPER_MANAGE,
  "chatbot-config": ROLE_PERMISSIONS.AUTOMATION_CHATBOT_VIEW,
  "chatbot-settings": ROLE_PERMISSIONS.AUTOMATION_CHATBOT_VIEW,
  "settings-user-management": ROLE_PERMISSIONS.ACCOUNT_USERS_MANAGE,
  "settings-audit-log": ROLE_PERMISSIONS.SECURITY_AUDIT_VIEW,
  "settings-property-management": ROLE_PERMISSIONS.ACCOUNT_PROPERTY_VIEW,
  "settings-import-data": ROLE_PERMISSIONS.ACCOUNT_IMPORT_MANAGE,
  "settings-import-data-details": ROLE_PERMISSIONS.ACCOUNT_IMPORT_MANAGE,
  "settings-export-data": ROLE_PERMISSIONS.ACCOUNT_EXPORT_VIEW,
  "settings-objects-contacts": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-contact-create-form": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-contact-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-contact-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-companies": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-company-create-form": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-company-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-company-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-leads": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-lead-create-form": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-lead-pipelines": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-lead-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-lead-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-deals": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-deal-pipelines": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-deal-create-form": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-deal-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-deal-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-orders": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-order-pipelines": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-order-create-form": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-order-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-order-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-tickets": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-ticket-pipelines": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-ticket-create-form": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-ticket-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-ticket-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-appointments": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-appointment-pipelines": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-appointment-create-form": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-appointment-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-appointment-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-meetings": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-meeting-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-meeting-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-payments": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-payment-create-form": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-payment-record-customization": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "settings-objects-payment-record-customization-detail": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
};

export const CRM_OBJECT_PERMISSION_MAP: Partial<
  Record<ObjectCode, CrmObjectPermissionKeys>
> = {
  product: {
    view: ROLE_PERMISSIONS.CRM_PRODUCT_VIEW,
    create: ROLE_PERMISSIONS.CRM_PRODUCT_MANAGE,
    edit: ROLE_PERMISSIONS.CRM_PRODUCT_UPDATE,
    update: ROLE_PERMISSIONS.CRM_PRODUCT_UPDATE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_PRODUCT_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_PRODUCT_BULKDELETE,
  },
  contact: {
    view: ROLE_PERMISSIONS.CRM_CONTACT_VIEW,
    create: ROLE_PERMISSIONS.CRM_CONTACT_CREATE,
    edit: ROLE_PERMISSIONS.CRM_CONTACT_UPDATE,
    update: ROLE_PERMISSIONS.CRM_CONTACT_UPDATE,
    delete: ROLE_PERMISSIONS.CRM_CONTACT_DELETE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_CONTACT_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_CONTACT_BULKDELETE,
  },
  company: {
    view: ROLE_PERMISSIONS.CRM_COMPANY_VIEW,
    create: ROLE_PERMISSIONS.CRM_COMPANY_CREATE,
    edit: ROLE_PERMISSIONS.CRM_COMPANY_UPDATE,
    update: ROLE_PERMISSIONS.CRM_COMPANY_UPDATE,
    delete: ROLE_PERMISSIONS.CRM_COMPANY_DELETE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_COMPANY_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_COMPANY_BULKDELETE,
  },
  appointment: {
    view: ROLE_PERMISSIONS.CRM_APPOINTMENT_VIEW,
    create: ROLE_PERMISSIONS.CRM_APPOINTMENT_CREATE,
    edit: ROLE_PERMISSIONS.CRM_APPOINTMENT_UPDATE,
    update: ROLE_PERMISSIONS.CRM_APPOINTMENT_UPDATE,
    delete: ROLE_PERMISSIONS.CRM_APPOINTMENT_DELETE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_APPOINTMENT_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_APPOINTMENT_BULKDELETE,
  },
  deal: {
    view: ROLE_PERMISSIONS.CRM_DEAL_VIEW,
    create: ROLE_PERMISSIONS.CRM_DEAL_CREATE,
    edit: ROLE_PERMISSIONS.CRM_DEAL_UPDATE,
    update: ROLE_PERMISSIONS.CRM_DEAL_UPDATE,
    delete: ROLE_PERMISSIONS.CRM_DEAL_DELETE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_DEAL_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_DEAL_BULKDELETE,
  },
  ticket: {
    view: ROLE_PERMISSIONS.CRM_TICKET_VIEW,
    create: ROLE_PERMISSIONS.CRM_TICKET_CREATE,
    edit: ROLE_PERMISSIONS.CRM_TICKET_UPDATE,
    update: ROLE_PERMISSIONS.CRM_TICKET_UPDATE,
    delete: ROLE_PERMISSIONS.CRM_TICKET_DELETE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_TICKET_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_TICKET_BULKDELETE,
  },
  lead: {
    view: ROLE_PERMISSIONS.CRM_LEAD_VIEW,
    create: ROLE_PERMISSIONS.CRM_LEAD_CREATE,
    edit: ROLE_PERMISSIONS.CRM_LEAD_UPDATE,
    update: ROLE_PERMISSIONS.CRM_LEAD_UPDATE,
    delete: ROLE_PERMISSIONS.CRM_LEAD_DELETE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_LEAD_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_LEAD_BULKDELETE,
  },
  meeting: {
    delete: ROLE_PERMISSIONS.CRM_MEETING_DELETE,
    create: ROLE_PERMISSIONS.CRM_MEETING_CREATE,
    edit: ROLE_PERMISSIONS.CRM_MEETING_UPDATE,
    update: ROLE_PERMISSIONS.CRM_MEETING_UPDATE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_MEETING_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_MEETING_BULKDELETE,
  },
  order: {
    delete: ROLE_PERMISSIONS.CRM_ORDER_DELETE,
    edit: ROLE_PERMISSIONS.CRM_ORDER_UPDATE,
    update: ROLE_PERMISSIONS.CRM_ORDER_UPDATE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_ORDER_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_ORDER_BULKDELETE,
  },
  payment: {
    delete: ROLE_PERMISSIONS.CRM_PAYMENT_DELETE,
    edit: ROLE_PERMISSIONS.CRM_PAYMENT_UPDATE,
    update: ROLE_PERMISSIONS.CRM_PAYMENT_UPDATE,
    bulkUpdate: ROLE_PERMISSIONS.CRM_PAYMENT_BULKUPDATE,
    bulkDelete: ROLE_PERMISSIONS.CRM_PAYMENT_BULKDELETE,
  },
};

export const getCrmObjectPermissionKey = (
  objectCode: ObjectCode | string | undefined,
  action: CrmObjectPermissionAction,
): RolePermissionKey | undefined =>
  objectCode
    ? CRM_OBJECT_PERMISSION_MAP[objectCode as ObjectCode]?.[action]
    : undefined;

export const SETTINGS_ROUTE_PERMISSION_MAP: Record<string, RolePermissionKey> = {
  "audit-log": ROLE_PERMISSIONS.SECURITY_AUDIT_VIEW,
  "user-management": ROLE_PERMISSIONS.ACCOUNT_USERS_MANAGE,
  "property-management": ROLE_PERMISSIONS.ACCOUNT_PROPERTY_VIEW,
  "import-data": ROLE_PERMISSIONS.ACCOUNT_IMPORT_MANAGE,
  "export-data": ROLE_PERMISSIONS.ACCOUNT_EXPORT_VIEW,
  objects: ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-contacts": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-companies": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-leads": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-deals": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-orders": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-tickets": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-appointments": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-meetings": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
  "object-payments": ROLE_PERMISSIONS.ACCOUNT_FORMS_MANAGE,
};

export const USER_MANAGEMENT_TAB_PERMISSION_MAP = {
  users: ROLE_PERMISSIONS.ACCOUNT_USERS_MANAGE,
  teams: ROLE_PERMISSIONS.ACCOUNT_USERS_MANAGE,
  roles: ROLE_PERMISSIONS.ACCOUNT_USERS_MANAGE,
  projects: ROLE_PERMISSIONS.ACCOUNT_PROJECTS_MANAGE,
} as const satisfies Record<string, RolePermissionKey>;

export const getRoutePermissionKey = (
  route: Pick<RouteItem, "id" | "permissionKey">,
): RolePermissionKey | undefined =>
  (route.permissionKey as RolePermissionKey | undefined) ??
  ROUTE_PERMISSION_MAP[route.id];

export const filterRoutesByPermissions = <T extends RouteItem>(
  routes: T[],
  permissionMap: RuntimePermissionMap,
  isSuperAdmin = false,
): T[] =>
  routes
    .map((route) => {
      const permissionKey = getRoutePermissionKey(route);
      if (!hasRuntimePermission(permissionMap, permissionKey, isSuperAdmin)) {
        return null;
      }

      if (!route.children?.length) return route;

      return {
        ...route,
        children: filterRoutesByPermissions(
          route.children,
          permissionMap,
          isSuperAdmin,
        ),
      };
    })
    .filter((route): route is T => route !== null);
